import { render, staticRenderFns } from "./ProductOptionGroupForm.vue?vue&type=template&id=65fe13a3&"
import script from "./ProductOptionGroupForm.vue?vue&type=script&lang=js&"
export * from "./ProductOptionGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports